import repository from '@/repository'
import { ActionTree, Module, MutationTree } from 'vuex'
import { RootState } from '../types'

const getDefaultState = (): ForgotPasswordState => {
  return {
    forgotPasswordIsLoading: false,
    forgotPasswordError: false,
    forgotPasswordSuccess: false,
    forgotPasswordErrorMessage: '',
    isSsoLogin: false,
    isSsoLoginLoading: false,
  }
}

const state = getDefaultState()

const mutations: MutationTree<ForgotPasswordState> = {
  reset(state) {
    Object.assign(state, getDefaultState())
  },
  setForgotPasswordSuccess(state, value) {
    state.forgotPasswordSuccess = value
  },
  setForgotPasswordIsLoading(state, value) {
    state.forgotPasswordIsLoading = value
  },
  setForgotPasswordError(state, value) {
    state.forgotPasswordError = value
  },
  setForgotPasswordErrorMessage(state, value) {
    state.forgotPasswordErrorMessage = value
  },
  setIsSsoLogin(state, value) {
    state.isSsoLogin = value
  },
  setIsSsoLoginLoading(state, value) {
    state.isSsoLoginLoading = value
  },
}

const actions: ActionTree<ForgotPasswordState, RootState> = {
  async checkIsSsoLogin({ commit }, payload) {
    commit('setIsSsoLoginLoading', true)
    return repository.User.IsSsoLogin(payload)
      .then((res) => {
        commit('setIsSsoLogin', res.data)
      })
      .catch(() => {
        commit('setIsSsoLogin', false)
      })
      .finally(() => {
        commit('setIsSsoLoginLoading', false)
      })
  },
  callForgotPassword({ commit }, payload) {
    commit('setForgotPasswordIsLoading', true)
    repository.User.ForgotPassword(payload)
      .then(() => {
        commit('setForgotPasswordError', false)
        commit('setForgotPasswordSuccess', true)
        commit('setForgotPasswordErrorMessage', '')
      })
      .catch((err) => {
        commit('setForgotPasswordError', true)
        commit('setForgotPasswordSuccess', false)
        commit(
          'setForgotPasswordErrorMessage',
          err.response.data.messageLocalizable
        )
      })
      .finally(() => {
        commit('setForgotPasswordIsLoading', false)
      })
  },
  resetForgotPasswordFlow({ commit }) {
    commit('setForgotPasswordError', false)
    commit('setForgotPasswordSuccess', false)
    commit('setForgotPasswordErrorMessage', '')
    commit('setIsSsoLogin', false)
    commit('setIsSsoLoginLoading', false)
  },
}

const ForgotPassword: Module<ForgotPasswordState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default ForgotPassword

interface ForgotPasswordState {
  forgotPasswordIsLoading: boolean
  forgotPasswordError: boolean
  forgotPasswordSuccess: boolean
  forgotPasswordErrorMessage: string
  isSsoLogin: boolean
  isSsoLoginLoading: boolean
}
